import { createPath } from '../_utils/createPath';

export const SESSION_QUERY_KEYS = {
  login: ['session', 'login'],
  logout: ['session', 'logout'],
};

export const session = {
  login: createPath('/login/'),
  logout: createPath('/login_out/'),
};
